module.exports = __webpack_public_path__ + "static/media/PST01@m.5b0803d7.jpg";